import React, {createContext, useContext} from 'react';
import {PageForType} from '../types/page';

interface PageContextType {
    pageFor: PageForType | null;
}

export const PageContext = createContext<PageContextType>({pageFor: null});

export const usePageContext = () => useContext(PageContext);

export const PageProvider: React.FC<{children: React.ReactNode; pageFor: PageForType | null}> = ({
    children,
    pageFor,
}) => {
    return <PageContext.Provider value={{pageFor}}>{children}</PageContext.Provider>;
};
